import Search from '@mui/icons-material/Search';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import { t } from 'i18next';
import { debounce } from 'lodash-es';
import { useEffect, useState } from 'react';

import { GLOBAL_DEBOUNCE_DEBOUNCE_DELAY_IN_MS } from '~constants/consts';

import { CONTROLS_HEIGHT_IN_PX } from '../constants';

interface SearchBarProps {
  onChange: (value: string) => void;
}

export default function SearchBar({ onChange }: SearchBarProps) {
  const theme = useTheme();
  const [value, setValue] = useState('');

  const applyDebouncedFilter = debounce((callback: () => void) => {
    callback();
  }, GLOBAL_DEBOUNCE_DEBOUNCE_DELAY_IN_MS);

  useEffect(() => {
    applyDebouncedFilter(() => {
      onChange(value);
    });

    return () => {
      applyDebouncedFilter.cancel();
    };
  }, [onChange, value]);

  return (
    <Box
      sx={{
        flex: 1,
      }}
    >
      <OutlinedInput
        fullWidth
        onChange={(e) => setValue(e.target.value)}
        placeholder={`${t('dispatch.dispatch_v2.copy_vendor_assignments.search_by_any_column')}`}
        size="small"
        value={value}
        startAdornment={
          <InputAdornment position="start">
            <Search
              sx={{
                color: theme.brandV2.colors.treadBlack,
                cursor: 'pointer',
                fontSize: '16px',
              }}
            />
          </InputAdornment>
        }
        sx={{
          '&.MuiInputBase-root': {
            height: CONTROLS_HEIGHT_IN_PX,
            px: 1,
            py: 0.5,
            '.MuiInputBase-input': { fontSize: '12px', p: 0 },
            '.MuiOutlinedInput-notchedOutline': {
              border: `solid 1px ${theme.brandV2.colors.treadGray7}`,
            },
          },
        }}
      />
    </Box>
  );
}
